/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import type { PluginBrand } from '@sportninja/common/features/account/apiAccess'
import { SettingsSection } from './SettingsSection'
import { ThemeColours } from './ThemeColours'
import { ThemeFonts } from './ThemeFonts'
import { ThemeLayout } from './ThemeLayout'
import { ThemeShape } from './ThemeShape'

interface ThemeGroupProps {
  brand: PluginBrand
}

/** The snippet's theme: colours, fonts, shape and spacing, and layout. */
export const ThemeGroup = ({ brand }: ThemeGroupProps) => (
  <div css={groupStyle}>
    <SettingsSection
      title='Colours'
      description="Light or dark, the league's colours and each area's own"
    >
      <ThemeColours brand={brand} />
    </SettingsSection>
    <SettingsSection
      title='Fonts'
      description='Body and heading fonts, size and letter spacing'
    >
      <ThemeFonts />
    </SettingsSection>
    <SettingsSection
      title='Shape & spacing'
      description='How round the corners are and how much room things get'
    >
      <ThemeShape />
    </SettingsSection>
    <SettingsSection
      title='Layout'
      description="The plugin's height and width, and where it sits when the page is wider"
    >
      <ThemeLayout />
    </SettingsSection>
  </div>
)

const groupStyle = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`
